import NetworkService, { Endpoint } from './NetworkService'

export default class SharedAppointmentSlotService {
  network
  constructor() {
    this.network = new NetworkService()
  }
  get(uuid: string) {
    return this.network.get(`${Endpoint.sharedAppointmentSlots}/${uuid}`)
  }
}
